import React from "react"
import { Link } from "react-router-dom"
import APP_INFO from "../../constants/appInfo"
import zenithSvg from "../../assets/zenith-logo.svg"
import "./BrandLogo.less"

export interface IBrandLogoProps {
  collapsed?: boolean
  size?: "small" | "default" | "large"
  showVersion?: boolean
  linkToHome?: boolean
  className?: string
}

export default function BrandLogo({
  collapsed = false,
  size = "default",
  showVersion = true,
  linkToHome = true,
  className = "",
}: IBrandLogoProps) {
  const content = (
    <div
      className={`zenith-brand-logo ${size} ${collapsed ? "collapsed" : ""} ${className}`}
      title={`${APP_INFO.name} ${APP_INFO.versionBadge}`}
    >
      <div className="logo-icon-wrapper">
        <img src={zenithSvg} alt="Zenith Digital Logo" className="logo-svg-mark" />
        <div className="logo-glow"></div>
      </div>

      {!collapsed && (
        <div className="logo-text-wrapper">
          <div className="brand-header-row">
            <span className="brand-name">ZENITH DIGITAL</span>
            {showVersion && (
              <span className="brand-version-badge" title={`Semantic Version: ${APP_INFO.version}`}>
                {APP_INFO.versionBadge}
              </span>
            )}
          </div>
          <span className="brand-tagline">CRP</span>
        </div>
      )}
    </div>
  )

  if (linkToHome) {
    return (
      <Link to="/" className="zenith-brand-link">
        {content}
      </Link>
    )
  }

  return content
}
